<template>
    <div class="content">
        <div class="container-fluid">
            <div class="preview-page">
                <div class="preview-layout">
                    <div class="card preview-sidebar">
                        <div class="loader" v-if="waiting"></div>
                        <label class="preview-dev-toggle">
                            <input type="checkbox" v-model="showDev">
                            Показать dev шаблоны
                        </label>
                        <div class="preview-sidebar-title">Категории</div>
                        <div class="preview-sidebar-list">
                            <draggable v-model="data"
                                       @start="onCategoriesDragStart"
                                       @end="onCategoriesDragEnd"
                                       @change="onCategoriesReorder">
                                <transition-group>
                                    <div class="category-list"
                                         v-for="element in data"
                                         :key="element.id"
                                         :class="{ active: isSelectedCategory(element.id) }"
                                         @click="selectCategory(element.id)">
                                        <span class="category-list-row">
                                            <span class="category-list-name">{{ element.name }}</span>
                                            <span class="category-off" v-if="isCategoryInactive(element.status)">Скрыта</span>
                                        </span>
                                    </div>
                                </transition-group>
                            </draggable>
                        </div>
                    </div>

                    <div class="card preview-main">
                        <div class="loader" v-if="waiting"></div>
                        <div class="app-area">
                            <div v-if="selectedCategory">
                                <p class="category-name">
                                    {{ selectedCategory.name }}
                                    <span class="category-count">({{ visiblePosts.length }})</span>
                                    <span class="category-off-note" v-if="isCategoryInactive(selectedCategory.status)">
                                        Категория не отображается в приложении
                                    </span>
                                </p>

                                <div v-if="visiblePosts.length > 0"
                                     class="templates-grid"
                                     :key="selectedCategory.id">
                                    <draggable v-model="visiblePosts"
                                               @start="onPostsDragStart"
                                               @end="onPostsDragEnd"
                                               @change="onPostsReorder(selectedCategory)">
                                        <div v-for="post in visiblePosts" :key="post.id"
                                             class="inline-div"
                                             @click.prevent="openPreview(previewMedia(post), post.id)">
                                            <div class="card-template"
                                                 :class="[cardRatioClass(post.ratio), { 'has-media': !!previewMedia(post) }]">
                                                <video v-if="cardVideoSrc(post)"
                                                       class="card-media"
                                                       muted loop autoplay playsinline
                                                       :poster="previewImage(post) || undefined"
                                                       :key="'v-' + post.id">
                                                    <source :src="cardVideoSrc(post)"
                                                            :type="getTemplateType()"/>
                                                </video>
                                                <img v-else-if="previewImage(post)"
                                                     class="card-media"
                                                     :src="previewImage(post)"
                                                     alt="">
                                                <span class="template-badge is-id">ID {{ post.id }}</span>
                                                <span class="template-badge is-dev" v-if="isDev(post.status)">DEV</span>
                                                <span class="template-badge is-free" v-if="isFree(post.is_premium)">free</span>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                                <p v-else class="preview-empty">{{ emptyListLabel }}</p>
                            </div>
                            <div class="preview-main-footer">
                                <button v-if="role === 302" type="submit" class="btn btn-success btn-fill btn-save"
                                        @click.prevent="save()">
                                    Сохранить
                                </button>
                            </div>

                            <div class="clearfix"></div>
                            <div class="video-bg" v-if="activePreview" @click.prevent="closePreview()"></div>
                            <div id="player" v-if="activePreview">
                                <video v-if="isVideo(activePreview)" onloadstart="this.volume=0.1" controls autoplay
                                       id="video_player" style="max-width: 100%;">
                                    <source v-bind:src="activePreview"/>
                                </video>
                                <img v-else :src="activePreview" class="preview-lightbox-image" alt="">
                                <button v-if="role === 302" type="button" class="btn btn-fill btn-close btn-default"
                                        @click.prevent="openPost()"
                                        v-bind:class="{ 'active-state': activePreview }">
                                    Редактировать
                                </button>
                                <button type="button" class="btn btn-fill btn-close"
                                        @click.prevent="closePreview()"
                                        v-bind:class="{ 'active-state': activePreview }">
                                    Закрыть
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const _ = require('lodash')
const axios = require('axios')
import draggable from 'vuedraggable'
import previewPage from 'src/mixins/previewPage'

export default {
    mixins: [previewPage],
    components: {
        draggable
    },
    props: {
        type: {
            type: String,
            default: 'carousel'
        }
    },
    created: function () {
        this.get();
    },
    data() {
        return {
            data: [],
            activePreview: "",
            previewType: this.type,
            waiting: false,
            categoryId: null,
            role: parseInt(localStorage.getItem('role')) || 0,
            activeId: null,
            postOrders: [],
            categoryOrderDirty: false,
            dragGuard: false,
            categoryDragGuard: false,
            showDev: true,
        }
    },
    computed: {
        selectedCategory: function () {
            const categoryId = parseInt(this.categoryId, 10);
            return _.find(this.data, function (category) {
                return parseInt(category.id, 10) === categoryId;
            }) || null;
        },
        emptyListLabel: function () {
            return this.previewType === 'stories' ? 'Нет сторис' : 'Нет каруселей';
        },
        hasUnsavedOrder: function () {
            return this.postOrders.length > 0 || this.categoryOrderDirty;
        },
        visiblePosts: {
            get: function () {
                const category = this.selectedCategory;
                if (!category || !category.posts) {
                    return [];
                }
                if (this.showDev) {
                    return category.posts;
                }
                const self = this;
                return _.filter(category.posts, function (post) {
                    return !self.isDev(post.status);
                });
            },
            set: function (posts) {
                const category = this.selectedCategory;
                if (!category) {
                    return;
                }
                if (this.showDev) {
                    category.posts = posts;
                    return;
                }
                const self = this;
                const queue = posts.slice();
                category.posts = _.map(category.posts, function (post) {
                    if (self.isDev(post.status)) {
                        return post;
                    }
                    return queue.length ? queue.shift() : post;
                });
            }
        }
    },
    methods: {
        get: function () {
            let self = this;

            let token = localStorage.getItem('token');

            self.waiting = true;

            axios.get(
                `${this.$hostname}/admin/posts/preview`,
                {
                    'params': {
                        type: this.previewType,
                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.waiting = false;
                    self.postOrders = [];
                    self.categoryOrderDirty = false;
                    self.data = response.data || [];
                    const selectedExists = _.some(self.data, function (category) {
                        return parseInt(category.id, 10) === parseInt(self.categoryId, 10);
                    });
                    if (!selectedExists && self.data.length) {
                        self.categoryId = self.data[0].id;
                    }
                })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error)
                })

        },
        save: function () {
            let self = this;

            let token = localStorage.getItem('token');

            self.waiting = true;

            axios.post(
                `${this.$hostname}/admin/posts/preview/resort`,
                {
                    categoryIds: this.categoryOrderDirty ? _.map(this.data, 'id') : [],
                    postOrders: this.postOrders,
                },
                {
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function () {
                    self.postOrders = [];
                    self.categoryOrderDirty = false;
                    self.get();
                })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error)
                })

        },
        onPostsDragStart: function () {
            this.dragGuard = true;
        },
        onPostsDragEnd: function () {
            setTimeout(() => {
                this.dragGuard = false;
            }, 150);
        },
        onCategoriesDragStart: function () {
            this.categoryDragGuard = true;
        },
        onCategoriesDragEnd: function () {
            setTimeout(() => {
                this.categoryDragGuard = false;
            }, 150);
        },
        onCategoriesReorder: function () {
            this.categoryOrderDirty = true;
        },
        isSelectedCategory: function (id) {
            return parseInt(id, 10) === parseInt(this.categoryId, 10);
        },
        selectCategory: function (id) {
            if (this.categoryDragGuard) {
                return;
            }
            this.categoryId = id;
        },
        onPostsReorder: function (category) {
            if (!category || !category.posts) {
                return;
            }

            const categoryId = parseInt(category.id, 10);
            const ids = _.map(category.posts, 'id');
            this.postOrders = _.filter(this.postOrders, function (order) {
                return parseInt(order.categoryId, 10) !== categoryId;
            });
            this.postOrders.push({
                categoryId: categoryId,
                ids: ids,
            });
            this.syncOtherCategoryOrders(categoryId, ids);
        },
        syncOtherCategoryOrders: function (sourceCategoryId, orderedIds) {
            const subset = {};
            _.forEach(orderedIds, function (id) {
                subset[id] = true;
            });

            _.forEach(this.data, function (category) {
                if (parseInt(category.id, 10) === sourceCategoryId || !category.posts || !category.posts.length) {
                    return;
                }

                const byId = {};
                _.forEach(category.posts, function (post) {
                    byId[post.id] = post;
                });

                const queue = [];
                _.forEach(orderedIds, function (id) {
                    if (byId[id]) {
                        queue.push(byId[id]);
                    }
                });

                if (!queue.length) {
                    return;
                }

                category.posts = _.map(category.posts, function (post) {
                    if (!subset[post.id]) {
                        return post;
                    }
                    return queue.length ? queue.shift() : post;
                });
            });
        },
        cardRatioClass: function (ratio) {
            const value = parseInt(ratio, 10);
            if (value === 2) {
                return 'is-wide';
            }
            if (value === 3) {
                return 'is-tall';
            }
            if (value === 4) {
                return 'is-square';
            }
            return 'is-portrait';
        },
        getTemplateType: function() {
            return 'video/mp4';
        },
        isVideo: function (url) {
            return url && url.indexOf('.mp4') > -1;
        },
        previewImage: function (post) {
            if (post.preview_src_full && !this.isVideo(post.preview_src_full)) {
                return post.preview_src_full;
            }
            return null;
        },
        cardVideoSrc: function (post) {
            if (post.video_src_full) {
                return post.video_src_full;
            }
            if (this.isVideo(post.preview_src_full)) {
                return post.preview_src_full;
            }
            return null;
        },
        previewMedia: function (post) {
            return this.cardVideoSrc(post) || this.previewImage(post) || '';
        },
        isDev: function (status) {
            return parseInt(status, 10) === 0;
        },
        isFree: function (isPremium) {
            return parseInt(isPremium, 10) !== 1;
        },
        openPreview: function (src, id) {
            if (this.dragGuard) {
                return;
            }
            this.activeId = id;
            this.activePreview = src;
        },
        openPost: function() {
            this.$router.push({
                name: 'edit-post',
                params: {id: this.activeId}
            });
        },
        closePreview: function () {
            this.activeId = null;
            this.activePreview = "";
        },
    }
}
</script>
<style scoped>

@import url('https://fonts.cdnfonts.com/css/sf-pro-display');

.preview-page {
    position: relative;
}

.preview-main-footer {
    margin: 24px 8px 4px;
}

.btn-save {
    width: 150px;
}

.preview-layout {
    display: flex;
    align-items: stretch;
    gap: 16px;
}

.preview-sidebar {
    width: 240px;
    flex-shrink: 0;
    margin-bottom: 0;
    position: relative;
    padding: 12px;
}

.preview-sidebar-title {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #9a9a9a;
    margin-bottom: 8px;
}

.preview-sidebar-list {
    max-height: calc(100vh - 220px);
    overflow-y: auto;
}

.preview-main {
    flex: 1;
    min-width: 0;
    margin-bottom: 0;
    position: relative;
}

.category-name {
    margin: 0 0 12px 8px;
    font-family: 'SF Pro Display', sans-serif !important;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: 0.5px;
}

.preview-dev-toggle {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 26px 0;
    margin: 0;
    font-size: 13px;
    font-weight: 500;
    color: #5e5e5e;
    white-space: nowrap;
    cursor: pointer;
}

.preview-dev-toggle input {
    margin: 0;
}

.category-count {
    color: #9a9a9a;
    font-weight: 400;
}

.preview-empty {
    margin: 0 8px 16px;
    color: #9a9a9a;
}

.app-area {
    width: 100%;
    overflow: auto;
    padding: 16px 8px 8px;
}

.category-list {
    width: 100%;
    height: 32px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 6px;
    cursor: pointer;
    text-align: left;
    line-height: 30px;
    padding: 0 10px;
    font-size: 13px;
    background: #fff;
}

.category-list-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.category-list.active,
.category-list.sortable-chosen {
    background-color: #000;
    color: #fff;
    border-color: #000;
}

.btn-close {
    display: none;
    width: 283px;
    height: 40px;
    margin: 10px auto;
    background: #000;
    border: none;
    -webkit-animation: .07s ease 0s normal forwards 1 fadein;
    animation: .07s ease 0s normal forwards 1 fadein;
    font-size: 15px;
}

.btn-close:hover {
    background: #000;
    opacity: 0.8 !important;
}

.btn-close.active-state {
    display: block;
}

@keyframes fadein {
    0% {
        opacity: 0;
    }
    66% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@-webkit-keyframes fadein {
    0% {
        opacity: 0;
    }
    66% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.inline-div {
    display: inline-block;
    position: relative;
    margin: 0 6px 10px 0;
    vertical-align: top;
}

.preview-sidebar-list::-webkit-scrollbar,
.app-area::-webkit-scrollbar {
    display: none;
}

.card {
    position: relative;
}

.templates-grid {
    width: 100%;
    margin-bottom: 8px;
    padding-left: 4px;
}

.templates-grid .card-template {
    display: inline-block;
}

.card-template {
    width: 105px;
    height: 131px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background-color: #eceaea;
}

.card-template.is-portrait {
    width: 105px;
    height: 131px;
}

.card-template.is-wide {
    width: 175px;
    height: 131px;
}

.card-template.is-tall {
    width: 105px;
    height: 186px;
}

.card-template.is-square {
    width: 131px;
    height: 131px;
}

.card-template.has-media {
    width: auto;
    height: 131px;
}

.card-template.has-media.is-tall {
    height: 186px;
}

.card-template .card-media {
    display: block;
    height: 100%;
    width: auto;
    max-height: 100%;
    object-fit: contain;
    cursor: pointer;
}

.template-badge {
    background-color: rgba(255, 255, 255, 0.6);
    color: black;
    padding-left: 5px;
    padding-right: 5px;
    position: absolute;
    left: 5px;
    font-size: 15px;
    border-radius: 2px;
}

.template-badge.is-count {
    top: 5px;
    font-size: 13px;
}

.template-badge.is-id {
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
}

.template-badge.is-dev {
    top: auto;
    left: 50%;
    right: auto;
    bottom: 34px;
    transform: translateX(-50%);
    background-color: rgba(255, 193, 7, 0.85);
    font-weight: 600;
}

.template-badge.is-free {
    top: 5px;
    right: 5px;
    left: auto;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    padding: 4px 6px;
    border-radius: 6px;
    color: #fff;
    background-color: #54abfe;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

.video-bg {
    position: fixed;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #000000;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10;
    opacity: 0.7;
}

#player {
    width: 324px;
    min-height: 200px;
    position: absolute;
    top: 0;
    background: #fff;
    z-index: 11;
    transition: all .3s ease-out;
    padding-bottom: 8px;
}

.preview-lightbox-image {
    display: block;
    width: 100%;
    height: auto;
}

@media (max-width: 768px) {
    .preview-layout {
        flex-direction: column;
    }

    .preview-sidebar {
        width: 100%;
    }

    .preview-sidebar-list {
        max-height: 220px;
    }
}
</style>
<style scoped src="../../../assets/css/preview-badges.css"></style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PostsPreview.vue